import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './non_empty_hub.less'
import FadeOutLink from 'components/common/fade_out_link'
import HubCampaign from '../hub_campaign'
import smoothScrollPolyfill from 'smoothscroll-polyfill'
import { groupArray } from 'shared/helpers/array_helpers'
import Separator from 'components/common/separator'
import PayPalPage from 'components/common/paypal_page'
import LearnMore from 'components/common/learn_more'

const i18n = getI18n('components/pages/hub/non_empty_hub')

class NonEmptyHub extends React.Component {
  static propTypes = {
    campaigns: PropTypes.array.isRequired,
  }

  componentDidMount() {
    smoothScrollPolyfill.polyfill()
  }

  handleLearnMore = () => {
    this.footer.scrollIntoView({ behavior: 'smooth' })
  }

  render() {
    const groupedCampaigns = groupArray(this.props.campaigns, 3)

    let alertElement

    return (
      <PayPalPage>
        <div styleName="container">
          {alertElement && (
            <div styleName="row">
              <div styleName="alert-col">{alertElement}</div>
            </div>
          )}
          <div styleName="top-area">
            <div styleName="title">{i18n('title')}</div>
            <div styleName="add-button-desktop-container">
              <FadeOutLink
                href={`${GLOBAL_CONSTS.REQUEST_URI}/c/create`}
                className="vx_addBtn-primary"
                data-pa-click="create"
                data-nemo="create-pool-button"
              >
                {i18n('add_action')}
              </FadeOutLink>
            </div>
          </div>

          <div styleName="row">
            <div styleName="separator-col">
              <Separator />
            </div>
          </div>

          <div styleName="add-button-mobile-container">
            <FadeOutLink
              href={`${GLOBAL_CONSTS.REQUEST_URI}/c/create`}
              className="vx_addBtn-primary"
              data-pa-click="create"
              data-nemo="mweb-create-pool-button"
            >
              {i18n('add_action')}
            </FadeOutLink>
          </div>

          <div styleName="clear" />

          {groupedCampaigns.map(campaignGroup => (
            <div styleName="campaign-row" key={campaignGroup[0].id}>
              {campaignGroup.map(campaign => (
                <div styleName="campaign-col" key={campaign.id}>
                  <HubCampaign campaign={campaign} />
                </div>
              ))}
            </div>
          ))}

          <div styleName="clear" />

          <footer
            ref={footer => {
              this.footer = footer
            }}
            styleName="hub-footer"
          >
            <div styleName="footer-header">{i18n('footer_header')}</div>
            <div styleName="learn-more-container">
              <LearnMore showArrow={true} />
            </div>
            <Separator type="dotted" />

            <div styleName="footer-actions">
              <div styleName="footer-actions-col">
                <div styleName="footer-action-row">
                  <div styleName="footer-action-col">
                    <div styleName="footer-action">
                      <div styleName="footer-action-title">
                        {i18n('footer_share')}
                      </div>
                      <p styleName="footer-action-text">
                        {i18n('footer_share_text')}
                      </p>
                    </div>
                  </div>
                  <div styleName="footer-action-col">
                    <div styleName="footer-action">
                      <div styleName="footer-action-title">
                        {i18n('footer_collect')}
                      </div>
                      <p styleName="footer-action-text">
                        {i18n('footer_collect_text')}
                      </p>
                    </div>
                  </div>
                </div>

                <div styleName="footer-action-row">
                  <div styleName="footer-action-col">
                    <div styleName="footer-action">
                      <div styleName="footer-action-title">
                        {i18n('footer_privacy')}
                      </div>
                      <p styleName="footer-action-text">
                        {i18n('footer_privacy_text')}
                      </p>
                    </div>
                  </div>
                  <div styleName="footer-action-col">
                    <div styleName="footer-action-last">
                      <div styleName="footer-action-title">
                        {i18n('footer_money')}
                      </div>
                      <p styleName="footer-action-text">
                        {i18n('footer_money_text')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div styleName="learn-more-col">
                <LearnMore showArrow={true} />
              </div>

              <div styleName="rocket-launch-col">
                <div styleName="rocket-launch" />
              </div>
            </div>

            <div styleName="clear" />
          </footer>
        </div>
      </PayPalPage>
    )
  }
}

export default cssModules(NonEmptyHub, styles)
